import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PageViewModel } from '@components/ui/table-template/models/page-view-model';
import { DocumentViewModel } from '../models/document.view-model';

@Component({
    selector: 'app-document-card',
    templateUrl: './document-card.component.html',
    styleUrls: ['./document-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AngularSvgIconModule]
})
export class DocumentCardComponent {
  public readonly currentPage = input<PageViewModel<DocumentViewModel>>();
  public readonly buttonClicked = output<DocumentViewModel>();
}
